module.exports = __webpack_public_path__ + "img/avatar.815de1e5.png";